import { ethers } from 'ethers';
import { NetworkConfig } from '../config/networks';

/**
 * Read-only EVM provider via the configured public RPC — no wallet required.
 * `staticNetwork` avoids eth_chainId auto-detection against flaky public endpoints.
 */
export function createEvmReadProvider(chain: NetworkConfig): ethers.JsonRpcProvider {
  const network = ethers.Network.from(chain.chainId);
  return new ethers.JsonRpcProvider(chain.rpcUrl, network, { staticNetwork: network });
}
